import Invoices from './Invoices.vue'
import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [{
  path: 'invoices',
  name: 'invoices',
  component: Invoices,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/invoices', i18n.t('Invoices'), 40, 'file-invoice', [], 'view_invoice'),
  routes: routes
}
